KnownServices = require 'app/scripts/db/known-services'
makeErrorEnum = require 'app/scripts/lib/make-error-enum'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
Promise = require 'bluebird'
t = require('app/scripts/views/internal/teacup-with-helpers')()
_ = require 'underscore'
ModelCache = require 'app/scripts/db/model-cache'
parseUrl = require 'url-parse'
{ sendPluginTrackEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'

FriendlyLinkError = makeErrorEnum 'FriendlyLink', [
  'BoardRequired'
]

formatCache = new window.Map()
formatRequestCache = new window.Map()

template = t.renderable ({ icon, text, idPlugin, monochrome }) ->
  t.img
    class: t.classify({
      'known-service-icon': true
      'plugin-icon': idPlugin?
      'mod-reset': monochrome == false
    })
    src: icon
  t.text text

module.exports = (el, board) ->
  els = if el.tagName? == 'A' then [el] else _.toArray(el.querySelectorAll('a'))

  Promise.map els, (el) ->
    # The URL serializer in HTMLHyperlinkElementUtils.href
    # (https://url.spec.whatwg.org/#concept-url-serializer) appends a slash
    # to the base url e.g. <a href="http://www.trello.com">Trello</a>
    # will return http://www.trello.com/. Unfortunately, this breaks any
    # comparison we make with the link's actual text node if the URL supplied
    # is a base URL with no trailing slash.
    parsedUrl = parseUrl(el.href)
    url = if el.textContent == parsedUrl.origin then parsedUrl.origin else parsedUrl.href

    # If the link already has custom text, leave it alone.
    # In some cases, the href is escaped and the textContent
    # isn't, so also check against the decoded url.
    if el.textContent !in [url, decodeURIComponent(url)]
      return

    cacheKey = "#{board?.id}:#{url}"

    Promise.try ->
      if !board
        throw new PluginRunner.Error.NotHandled("no board specified")

      if formatCache.get(cacheKey)
        return formatCache.get(cacheKey)

      if formatRequestCache.get(cacheKey)
        return formatRequestCache.get(cacheKey)

      formatRequest = PluginRunner.one
        command: 'format-url'
        board: board
        options:
          url: url

      formatRequestCache.set(cacheKey, formatRequest)
      formatRequest
    .catch PluginRunner.Error.NotHandled, ->
      null
    .then (pluginResult) ->
      formatRequestCache.delete(cacheKey)
      if pluginResult?.text?
        sendPluginTrackEvent(pluginResult.idPlugin, {
          action: 'formatted'
          actionSubject: 'url'
          source: 'powerUpFormatUrl'
        })

        return pluginResult
      else
        KnownServices.interpret(el.href, ModelCache)
    .then (known) ->
      if known?
        formatCache.set(cacheKey, known)
        el.classList.add 'known-service-link'
        el.innerHTML = template(known)
